<div class="container {{ hasCheckOldPassword ? 'p-5' : ' pb-1' }}">
    <form class="reset-form" [formGroup]="pwdForm" (ngSubmit)="resetPassword()">
        <div class="my-3">
            <label for="email" class="form-label">Email</label>
            <input formControlName="email" type="email" class="form-control" value="email" id="email" readonly />
        </div>
        <div class="my-3 {{ hasCheckOldPassword ? '' : 'd-none' }}">
            <label for="oldPassword" class="form-label">Password corrente *</label>
            <input formControlName="oldPassword" type="password" class="form-control" id="oldPassword" [class.is-invalid]="(pwdForm.get('oldPassword')?.touched || pwdForm.get('oldPassword')?.dirty) && pwdForm.get('oldPassword')?.invalid" />
            <span *ngIf="pwdForm.get('oldPassword')?.invalid && pwdForm.get('oldPassword')?.touched" class="invalid-feedback">Password inserita non corretta</span>
        </div>
        <div class="my-3">
            <label for="newpassword" class="form-label">Nuova password *</label>
            <input formControlName="newpassword" type="password" class="form-control" id="newpassword" [class.is-invalid]="(pwdForm.get('newpassword')?.touched || pwdForm.get('newpassword')?.dirty) && pwdForm.get('newpassword')?.invalid" />
        </div>
        <div class="my-3">
            <label for="confirmpassword" class="form-label">Conferma nuova password *</label>
            <input formControlName="confirmpassword" type="password" class="form-control" id="confirmpassword" [class.is-invalid]="pwdForm.get('newpassword')?.touched && (pwdForm.get('newpassword')?.invalid || !checkEqualPwds())" />
            <span *ngIf="!checkEqualPwds() && pwdForm.get('confirmpassword')?.value" class="invalid-feedback">Le password inserite risultano diverse</span>
        </div>
        <p>Assicurati che la password soddisfi i seguenti requisiti:</p>
        <ul class="font-14 text-secondary mb-5">
            <li *ngFor="let error of criterias" [class.nv-check-elem]="pwdForm.get('newpassword')?.value && !error.checkError(error.type)">
                <span *ngIf="!pwdForm.get('newpassword')?.value || error.checkError(error.type); else liElem">{{ error.message }} </span>
                <ng-template #liElem> <fa-icon class="text-success" [icon]="['fas', 'check']"></fa-icon> {{ error.message }} </ng-template>
            </li>
        </ul>
        <div class="mx-auto d-flex justify-content-center">
            <button *ngIf="hasCheckOldPassword" (click)="activeModal.close(false)" type="submit" class="btn btn-outline me-3">Annulla</button>
            <button type="submit" class="btn btn-primary resetBtn" [disabled]="pwdForm.invalid">Reset password</button>
        </div>
    </form>
    <div class="loading" *ngIf="calling; else alerts">
        <app-loading name="filterLoading" [fullScreen]="false" [show]="true"></app-loading>
    </div>
    <ng-template #alerts>
        <div class="alert alert-danger mt-4" role="alert" *ngIf="errorReset">
            {{ message }}
        </div>
        <div class="alert alert-success mt-4" role="alert" *ngIf="completeReset">
            {{ message }}
        </div>
    </ng-template>
</div>
